<!-- 方案 -->
<template>
  <div class="page">
    <!-- 横幅 -->
    <Banner></Banner>
    <!-- 生态 -->
    <Ecosystem></Ecosystem>
    <!-- 价值共生 -->
    <ValueSymbiosis></ValueSymbiosis>
    <!-- 工单体系 -->
    <OrderSystem></OrderSystem>
    <!-- 三大工单类型 -->
    <OrderTypes></OrderTypes>
    <!-- 如何成为云企业 -->
    <BecomeProvider></BecomeProvider>
  </div>
</template>

<script>
import Banner from "./components/Banner.vue";
import Ecosystem from "./components/Ecosystem.vue";
import ValueSymbiosis from "./components/ValueSymbiosis.vue";
import OrderSystem from "./components/OrderSystem.vue";
import OrderTypes from "./components/OrderTypes.vue";
import BecomeProvider from "./components/BecomeProvider.vue";

export default {
  components: {
    Banner,
    Ecosystem,
    ValueSymbiosis,
    OrderSystem,
    OrderTypes,
    BecomeProvider
  }
};
</script>

<style lang="less" scoped>
</style>
